// This file is auto-generated - DO NOT EDIT - it will be overwritten. 

import Dashboard from "pages/dashboard";
import ExternalWorkorder from "pages/external/pages/workorder";
import NewsList from "pages/news/pages/list";
import NewsListRead from "pages/news/pages/list/pages/read";
import NewsAdmin from "pages/news/pages/admin";
import NewsAdminAdd from "pages/news/pages/admin/pages/add";
import NewsAdminEdit from "pages/news/pages/admin/pages/edit";
import LearningUser from "pages/learning/pages/user";
import LearningUserExamsDetails from "pages/learning/pages/user/pages/exams/pages/details";
import LearningUserExamsExamination from "pages/learning/pages/user/pages/exams/pages/examination";
import LearningUserExamsFinished from "pages/learning/pages/user/pages/exams/pages/finished";
import LearningAdmin from "pages/learning/pages/admin";
import LearningAdminExamsDetails from "pages/learning/pages/admin/pages/exams/pages/details";
import LearningAdminResults from "pages/learning/pages/admin/pages/results";
import LearningAdminResultsDetails from "pages/learning/pages/admin/pages/results/pages/details";
import Planning from "pages/planning";
import PlanningSchedule from "pages/planning/pages/schedule";
import PlanningAssignment from "pages/planning/pages/assignment";
import PlanningEcodriving from "pages/planning/pages/ecodriving";
import IssuereportsDashboard from "pages/issuereports/pages/dashboard";
import IssuereportsArchive from "pages/issuereports/pages/archive";
import IssuereportsArchiveIssuereport from "pages/issuereports/pages/archive/pages/issuereport";
import IssuereportsWorkorders from "pages/issuereports/pages/workorders";
import IssuereportsWorkordersAdd from "pages/issuereports/pages/workorders/pages/add";
import IssuereportsWorkordersDetails from "pages/issuereports/pages/workorders/pages/details";
import IssuereportsArchiveCategories from "pages/issuereports/pages/archive/pages/categories";
import Deviation from "pages/deviation";
import DeviationList from "pages/deviation/pages/list";
import DeviationListCreate from "pages/deviation/pages/list/pages/create";
import DeviationListDetails from "pages/deviation/pages/list/pages/details";
import Reports from "pages/reports";
import ReportsVehiclereports from "pages/reports/pages/vehiclereports";
import ReportsVehiclereportsReporttemplates from "pages/reports/pages/vehiclereports/pages/reporttemplates";
import ReportsVehiclereportsReporttemplatesAdd from "pages/reports/pages/vehiclereports/pages/reporttemplates/pages/add";
import ReportsVehiclereportsReporttemplatesEdit from "pages/reports/pages/vehiclereports/pages/reporttemplates/pages/edit";
import ReportsVehiclereportsFueldata from "pages/reports/pages/vehiclereports/pages/fueldata";
import ReportsVehiclereportsFueldataImport from "pages/reports/pages/vehiclereports/pages/fueldata/pages/import";
import ReportsVehiclereportsContract from "pages/reports/pages/vehiclereports/pages/contract";
import ReportsVehiclereportsContractImport from "pages/reports/pages/vehiclereports/pages/contract/pages/import";
import ReportsVehiclereportsContractEdit from "pages/reports/pages/vehiclereports/pages/contract/pages/edit";
import ReportsVehiclereportsContractAdd from "pages/reports/pages/vehiclereports/pages/contract/pages/add";
import ReportsUserreports from "pages/reports/pages/userreports";
import ReportsUserreportsReporttemplates from "pages/reports/pages/userreports/pages/reporttemplates";
import ReportsUserreportsReporttemplatesAdd from "pages/reports/pages/userreports/pages/reporttemplates/pages/add";
import ReportsUserreportsReporttemplatesEdit from "pages/reports/pages/userreports/pages/reporttemplates/pages/edit";
import ReportsUserreportsBkychecks from "pages/reports/pages/userreports/pages/bkychecks";
import Violation from "pages/violation";
import ViolationDetails from "pages/violation/pages/details";
import ViolationAdmin from "pages/violation/pages/admin";
import Vehiclealarm from "pages/vehiclealarm";
import VehiclealarmSettings from "pages/vehiclealarm/pages/settings";
import VehicleregistryDashboard from "pages/vehicleregistry/pages/dashboard";
import VehicleregistryVehicles from "pages/vehicleregistry/pages/vehicles";
import VehicleregistryChecks from "pages/vehicleregistry/pages/checks";
import VehicleregistryCalendar from "pages/vehicleregistry/pages/calendar";
import VehicleregistryVehiclesDetails from "pages/vehicleregistry/pages/vehicles/pages/details";
import VehicleregistrySettings from "pages/vehicleregistry/pages/settings";
import VehicleregistryVehiclesImport from "pages/vehicleregistry/pages/vehicles/pages/import";
import VehicleregistryVehiclesImportvtr from "pages/vehicleregistry/pages/vehicles/pages/importvtr";
import Map from "pages/map";
import Documents from "pages/documents";
import DocumentsDetails from "pages/documents/pages/details";
import DocumentsEdit from "pages/documents/pages/edit";
import Assembly from "pages/assembly";
import Payslip from "pages/payslip";
import CustomerSettingsCustomer from "pages/customer/pages/settings/pages/customer";
import CustomerSettingsCompanies from "pages/customer/pages/settings/pages/companies";
import CustomerSettingsCompaniesAdd from "pages/customer/pages/settings/pages/companies/pages/add";
import CustomerSettingsCompaniesEdit from "pages/customer/pages/settings/pages/companies/pages/edit";
import CustomerSettingsUsers from "pages/customer/pages/settings/pages/users";
import CustomerSettingsUsersAdd from "pages/customer/pages/settings/pages/users/pages/add";
import CustomerSettingsUsersEdit from "pages/customer/pages/settings/pages/users/pages/edit";
import CustomerSettingsUsersEditPasswordreset from "pages/customer/pages/settings/pages/users/pages/edit/pages/passwordreset";
import CustomerSettingsUsersCustomfields from "pages/customer/pages/settings/pages/users/pages/customfields";
import SystemadminCustomers from "pages/systemadmin/pages/customers";
import SystemadminCustomersAdd from "pages/systemadmin/pages/customers/pages/add";
import SystemadminCustomersEdit from "pages/systemadmin/pages/customers/pages/edit";
import SystemadminCustomersEditCustomer from "pages/systemadmin/pages/customers/pages/edit/pages/customer";
import SystemadminCustomersEditCompanies from "pages/systemadmin/pages/customers/pages/edit/pages/companies";
import SystemadminCustomersEditCompaniesAdd from "pages/systemadmin/pages/customers/pages/edit/pages/companies/pages/add";
import SystemadminCustomersEditCompaniesEdit from "pages/systemadmin/pages/customers/pages/edit/pages/companies/pages/edit";
import SystemadminCustomersEditUsers from "pages/systemadmin/pages/customers/pages/edit/pages/users";
import SystemadminCustomersEditUsersAdd from "pages/systemadmin/pages/customers/pages/edit/pages/users/pages/add";
import SystemadminCustomersEditUsersEdit from "pages/systemadmin/pages/customers/pages/edit/pages/users/pages/edit";
import SystemadminCustomersEditUsersEditPasswordreset from "pages/systemadmin/pages/customers/pages/edit/pages/users/pages/edit/pages/passwordreset";
import SystemadminCustomersEditUsersImport from "pages/systemadmin/pages/customers/pages/edit/pages/users/pages/import";
import SystemadminCustomersEditUsersImportlegacyexams from "pages/systemadmin/pages/customers/pages/edit/pages/users/pages/importlegacyexams";
import SystemadminLearning from "pages/systemadmin/pages/learning";
import SystemadminLearningExamDetails from "pages/systemadmin/pages/learning/pages/exam/pages/details";
import SystemadminDevices from "pages/systemadmin/pages/devices";
import SystemadminDevicesRegister from "pages/systemadmin/pages/devices/pages/register";
import SystemadminDevicesRegisterAdd from "pages/systemadmin/pages/devices/pages/register/pages/add";
import SystemadminDevicesRegisterEdit from "pages/systemadmin/pages/devices/pages/register/pages/edit";
import SystemadminDevicesEquipment from "pages/systemadmin/pages/devices/pages/equipment";
import SystemadminDevicesEquipmentAdd from "pages/systemadmin/pages/devices/pages/equipment/pages/add";
import SystemadminDevicesEquipmentEdit from "pages/systemadmin/pages/devices/pages/equipment/pages/edit";
import SystemadminDevicesStorage from "pages/systemadmin/pages/devices/pages/storage";
import SystemadminDevicesStorageAdd from "pages/systemadmin/pages/devices/pages/storage/pages/add";
import SystemadminDevicesStorageEdit from "pages/systemadmin/pages/devices/pages/storage/pages/edit";
import SystemadminDevicesTechnicalpackage from "pages/systemadmin/pages/devices/pages/technicalpackage";
import SystemadminDevicesSystemevents from "pages/systemadmin/pages/devices/pages/systemevents";
import SystemadminSystemEvents from "pages/systemadmin/pages/system/pages/events";
import CrisismanagementCrisisinfo from "pages/crisismanagement/pages/crisisinfo";
import UserSettings from "pages/user/pages/settings";
import UserSettingsPasswordchange from "pages/user/pages/settings/pages/passwordchange";

export const knownComponents = {
	Dashboard:Dashboard,
	ExternalWorkorder:ExternalWorkorder,
	NewsList:NewsList,
	NewsListRead:NewsListRead,
	NewsAdmin:NewsAdmin,
	NewsAdminAdd:NewsAdminAdd,
	NewsAdminEdit:NewsAdminEdit,
	LearningUser:LearningUser,
	LearningUserExamsDetails:LearningUserExamsDetails,
	LearningUserExamsExamination:LearningUserExamsExamination,
	LearningUserExamsFinished:LearningUserExamsFinished,
	LearningAdmin:LearningAdmin,
	LearningAdminExamsDetails:LearningAdminExamsDetails,
	LearningAdminResults:LearningAdminResults,
	LearningAdminResultsDetails:LearningAdminResultsDetails,
	Planning:Planning,
	PlanningSchedule:PlanningSchedule,
	PlanningAssignment:PlanningAssignment,
	PlanningEcodriving:PlanningEcodriving,
	IssuereportsDashboard:IssuereportsDashboard,
	IssuereportsArchive:IssuereportsArchive,
	IssuereportsArchiveIssuereport:IssuereportsArchiveIssuereport,
	IssuereportsWorkorders:IssuereportsWorkorders,
	IssuereportsWorkordersAdd:IssuereportsWorkordersAdd,
	IssuereportsWorkordersDetails:IssuereportsWorkordersDetails,
	IssuereportsArchiveCategories:IssuereportsArchiveCategories,
	Deviation:Deviation,
	DeviationList:DeviationList,
	DeviationListCreate:DeviationListCreate,
	DeviationListDetails:DeviationListDetails,
	Reports:Reports,
	ReportsVehiclereports:ReportsVehiclereports,
	ReportsVehiclereportsReporttemplates:ReportsVehiclereportsReporttemplates,
	ReportsVehiclereportsReporttemplatesAdd:ReportsVehiclereportsReporttemplatesAdd,
	ReportsVehiclereportsReporttemplatesEdit:ReportsVehiclereportsReporttemplatesEdit,
	ReportsVehiclereportsFueldata:ReportsVehiclereportsFueldata,
	ReportsVehiclereportsFueldataImport:ReportsVehiclereportsFueldataImport,
	ReportsVehiclereportsContract:ReportsVehiclereportsContract,
	ReportsVehiclereportsContractImport:ReportsVehiclereportsContractImport,
	ReportsVehiclereportsContractEdit:ReportsVehiclereportsContractEdit,
	ReportsVehiclereportsContractAdd:ReportsVehiclereportsContractAdd,
	ReportsUserreports:ReportsUserreports,
	ReportsUserreportsReporttemplates:ReportsUserreportsReporttemplates,
	ReportsUserreportsReporttemplatesAdd:ReportsUserreportsReporttemplatesAdd,
	ReportsUserreportsReporttemplatesEdit:ReportsUserreportsReporttemplatesEdit,
	ReportsUserreportsBkychecks:ReportsUserreportsBkychecks,
	Violation:Violation,
	ViolationDetails:ViolationDetails,
	ViolationAdmin:ViolationAdmin,
	Vehiclealarm:Vehiclealarm,
	VehiclealarmSettings:VehiclealarmSettings,
	VehicleregistryDashboard:VehicleregistryDashboard,
	VehicleregistryVehicles:VehicleregistryVehicles,
	VehicleregistryChecks:VehicleregistryChecks,
	VehicleregistryCalendar:VehicleregistryCalendar,
	VehicleregistryVehiclesDetails:VehicleregistryVehiclesDetails,
	VehicleregistrySettings:VehicleregistrySettings,
	VehicleregistryVehiclesImport:VehicleregistryVehiclesImport,
	VehicleregistryVehiclesImportvtr:VehicleregistryVehiclesImportvtr,
	Map:Map,
	Documents:Documents,
	DocumentsDetails:DocumentsDetails,
	DocumentsEdit:DocumentsEdit,
	Assembly:Assembly,
	Payslip:Payslip,
	CustomerSettingsCustomer:CustomerSettingsCustomer,
	CustomerSettingsCompanies:CustomerSettingsCompanies,
	CustomerSettingsCompaniesAdd:CustomerSettingsCompaniesAdd,
	CustomerSettingsCompaniesEdit:CustomerSettingsCompaniesEdit,
	CustomerSettingsUsers:CustomerSettingsUsers,
	CustomerSettingsUsersAdd:CustomerSettingsUsersAdd,
	CustomerSettingsUsersEdit:CustomerSettingsUsersEdit,
	CustomerSettingsUsersEditPasswordreset:CustomerSettingsUsersEditPasswordreset,
	CustomerSettingsUsersCustomfields:CustomerSettingsUsersCustomfields,
	SystemadminCustomers:SystemadminCustomers,
	SystemadminCustomersAdd:SystemadminCustomersAdd,
	SystemadminCustomersEdit:SystemadminCustomersEdit,
	SystemadminCustomersEditCustomer:SystemadminCustomersEditCustomer,
	SystemadminCustomersEditCompanies:SystemadminCustomersEditCompanies,
	SystemadminCustomersEditCompaniesAdd:SystemadminCustomersEditCompaniesAdd,
	SystemadminCustomersEditCompaniesEdit:SystemadminCustomersEditCompaniesEdit,
	SystemadminCustomersEditUsers:SystemadminCustomersEditUsers,
	SystemadminCustomersEditUsersAdd:SystemadminCustomersEditUsersAdd,
	SystemadminCustomersEditUsersEdit:SystemadminCustomersEditUsersEdit,
	SystemadminCustomersEditUsersEditPasswordreset:SystemadminCustomersEditUsersEditPasswordreset,
	SystemadminCustomersEditUsersImport:SystemadminCustomersEditUsersImport,
	SystemadminCustomersEditUsersImportlegacyexams:SystemadminCustomersEditUsersImportlegacyexams,
	SystemadminLearning:SystemadminLearning,
	SystemadminLearningExamDetails:SystemadminLearningExamDetails,
	SystemadminDevices:SystemadminDevices,
	SystemadminDevicesRegister:SystemadminDevicesRegister,
	SystemadminDevicesRegisterAdd:SystemadminDevicesRegisterAdd,
	SystemadminDevicesRegisterEdit:SystemadminDevicesRegisterEdit,
	SystemadminDevicesEquipment:SystemadminDevicesEquipment,
	SystemadminDevicesEquipmentAdd:SystemadminDevicesEquipmentAdd,
	SystemadminDevicesEquipmentEdit:SystemadminDevicesEquipmentEdit,
	SystemadminDevicesStorage:SystemadminDevicesStorage,
	SystemadminDevicesStorageAdd:SystemadminDevicesStorageAdd,
	SystemadminDevicesStorageEdit:SystemadminDevicesStorageEdit,
	SystemadminDevicesTechnicalpackage:SystemadminDevicesTechnicalpackage,
	SystemadminDevicesSystemevents:SystemadminDevicesSystemevents,
	SystemadminSystemEvents:SystemadminSystemEvents,
	CrisismanagementCrisisinfo:CrisismanagementCrisisinfo,
	UserSettings:UserSettings,
	UserSettingsPasswordchange:UserSettingsPasswordchange,
}
